export const INVITATION_STYLE = `
  .message h1,
  .message h2 {
    color: #000000 !important;
  }

  .message .ql-align-right {
    text-align: right;
  }
  .message .ql-align-center {
    text-align: center;
  }
  .message .ql-align-left {
    text-align: left;
  }
    
  .message li.ql-align-right {
    text-align: right;
  }
  .message li.ql-align-center {
    text-align: center;
  }
  .message li.ql-align-left {
    text-align: left;
  }
`;